import { CommonModule } from '@angular/common';
import { Component, OnInit, Inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { HeaderComponent as GbHeaderComponent } from '@bookinglab/govbook-ui/layout';
import {
  ImageDetail,
  NavLink,
} from '@bookinglab/govbook-ui/layout/lib/util/model';
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: true,
  imports: [CommonModule, GbHeaderComponent, MatIconModule],
})
export class HeaderComponent {
  goToWebsite() {
    window.open('https://www.westminster.gov.uk/', '_blank', 'noopener,noreferrer');
  }

  imageDetail: ImageDetail = {
    alt: 'City of Westminster',
    src: 'assets/westminster-logo.png',
  };

  navigation: NavLink[] = [
    {
      text: 'Residents',
      url: 'https://www.westminster.gov.uk/residents',
    },
    {
      text: 'Businesses',
      url: 'https://www.westminster.gov.uk/businesses',
    },
    // {
    //   text: 'MyWestminster accounts',
    //   url: 'https://www.westminster.gov.uk/portals',
    // },
  ];

  search(term: string) {
    const formatted = term.trim().replace(/\s+/g, '+');
    const url = `https://www.westminster.gov.uk/search?keys=${formatted}`;
    window.location.href = url;
  }
}
